export const gridPinnedColumnsSelector = state => state.pinnedColumns;